export const DEFAULT_LANGUAGE = 'NON';

export const LANG_TRANS: { [key: string]: string } = {
    [DEFAULT_LANGUAGE]: 'original',
    MT: 'Malta',
    HU: 'Magyarország',
    CS: 'Česká republika',
    BG: 'български',
    BS: 'Bosanski',
    CZ: 'Čeština',
    DA: 'Dansk',
    DE: 'Deutsch',
    EL: 'Ελληνικά',
    EN: 'English',
    ES: 'Español',
    ET: 'Eesti keel',
    FI: 'suomi',
    FR: 'Français',
    HR: 'Hrvatski',
    GR: 'Ελληνικά',
    ID: 'Bahasa Indonesia',
    IT: 'Italiano',
    JP: '日本語',
    KO: '한국어',
    KR: '한국어',
    LT: 'Lietuvių',
    LV: 'Latviešu',
    MO: '繁体中文',
    NL: 'Nederlands',
    NO: 'Norsk',
    PL: 'Polski',
    PT: 'Português',
    RO: 'Română',
    RU: 'Русский',
    SK: 'slovenčina',
    SL: 'Slovenščina',
    SR: 'Српски',
    SV: 'Svenska',
    TR: 'Türkçe',
    CN: '简体中文',
    CNT: '繁体中文',
    TW: '繁体中文',
};
